import Drawer from '@mui/material/Drawer';
import styled from '@emotion/styled';
import { alpha } from '@mui/material/styles';
import { useSelector } from 'react-redux';

import SidebarNav from './SidebarNav';
import Copyright from '../Copyright';
import { isModeModalSelector, isSidebarOpenSelector } from '../../state';

const drawerWidth = 320;

const ListContainer = styled('div', {
  shouldForwardProp: prop => prop !== 'open',
})<{ open: boolean }>`
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: ${({ theme, open }) => (open ? theme.spacing(1.5, 0.75) : theme.spacing(1, 0.5))};
`;

const StyDrawer = styled(Drawer, {
  shouldForwardProp: prop => prop !== 'open',
})(({ theme, open }) => ({
  '& .MuiDrawer-paper': {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    borderRight: `1px solid ${theme.palette.divider}`,
    background:
      theme.palette.mode === 'dark'
        ? `linear-gradient(180deg, ${alpha(theme.palette.common.white, 0.06)}, ${alpha(
            theme.palette.common.white,
            0.02
          )})`
        : `linear-gradient(180deg, ${alpha(theme.palette.common.white, 0.96)}, ${alpha(
            theme.palette.common.white,
            0.82
          )})`,
    boxShadow:
      theme.palette.mode === 'dark'
        ? `12px 0 34px ${alpha(theme.palette.common.black, 0.24)}`
        : `12px 0 34px ${alpha(theme.palette.text.primary, 0.06)}`,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: 'border-box',
    ...(!open && {
      overflowX: 'hidden',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(8),
      [theme.breakpoints.up('sm')]: {
        width: theme.spacing(8),
      },
    }),
  },
}));

const Sidebar = () => {
  const isModeModal = useSelector(isModeModalSelector);
  const isSidebarOpen = useSelector(isSidebarOpenSelector);

  return !isModeModal ? (
    <StyDrawer variant="permanent" open={isSidebarOpen}>
      <ListContainer open={isSidebarOpen} data-tour="sidebar-main-nav">
        <SidebarNav isSidebarOpen={isSidebarOpen} />
        {isSidebarOpen && <Copyright yearSecondLine />}
      </ListContainer>
    </StyDrawer>
  ) : null;
};

export default Sidebar;
